const imgRoot = '/static/imgs/'

export default {
  loginHold: `${imgRoot}login_back.jpg`,
  successIcon: `${imgRoot}icon_success.png`,
  enterpriseLogo: `${imgRoot}avatar.png`, //demo的头像
  homeHolder: `${imgRoot}home_holder.png`
}



// WEBPACK FOOTER //
// ./src/config/imgList.js